<template>
  <div class="text-center">
    <v-dialog
      v-model="value.active"
      max-width="1400"
      persistent
      scrollable
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="validar()">
          <v-card>
            <v-card-title class="dialog-especialidad-titulo text-h5">
              <h3>
                {{ value.especialidad.Id ? `Editando: ` : 'Nueva Especialidad' }}
              </h3>
              <span
                v-if="value.especialidad.NombreCompleto"
                class="ml-2"
                v-html="value.especialidad.NombreCompleto"
              />
            </v-card-title>

            <v-card-text class="chk-especialidades__main">
              <v-row>
                <v-col class="col-12">
                  <v-row>
                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:255"
                        name="Nombre Especialidad"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">Nombre *</label>
                          </template>
                          <ul>
                            <li>
                              Nombre de la Especialidad
                            </li>
                            <li v-if="!!value.especialidad.Id">
                              No editable**
                            </li>
                          </ul>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.Nombre"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                          :disabled="!!value.especialidad.Id"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:50"
                        name="Enlace"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">
                              Enlace *<span class="label-span"> (<b>formato:</b> psicologia-adulto)</span>
                            </label>
                          </template>
                          <ul>
                            <li>
                              URL que se asignará al Tipo de Especialidad
                            </li>
                            <li v-if="!!value.especialidad.Id">
                              No editable**
                            </li>
                          </ul>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.ToLink"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          :disabled="!!value.especialidad.Id"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Título H1"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">Título H1 *</label>
                          </template>
                          <span>Título Principal de la estructura SEO</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.H1Titulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:250"
                        name="Meta Title"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">Meta Title *</label>
                          </template>
                          <span>Título a mostrar en pestaña (considerar SEO)</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.MetaTitle"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col v-if="value.especialidad.Imagen" class="col-12 col-md-12 pb-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <label v-bind="attrs" class="label-img" v-on="on">
                            Nombre archivo actual: <span v-html="value.especialidad.Imagen" />
                          </label>
                        </template>
                        <span>Nombre base de la imagen actual. Recuerda subir ambas versiones (Desktop/Mobile).</span>
                      </v-tooltip>
                    </v-col>

                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Archivo Desktop"
                        :rules="`${value.imagenMobile ? 'required|' : ''}ext:jpg,png,jpeg,webp|size:5000`"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                              v-html="value.especialidad.Imagen ? 'Cambiar Imagen Desktop' : 'Subir Imagen Desktop'"
                            />
                          </template>
                          <span>Imagen para resolución de escritorio (Sugerido: 1900x530px). Máx 5MB.</span>
                        </v-tooltip>
                        <v-file-input
                          v-model="value.imagen"
                          small-chips
                          :error-messages="errors"
                          label="Formato: jpg, png, webp"
                          dense
                          filled
                          color="success"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Archivo Mobile"
                        :rules="`${value.imagen ? 'required|' : ''}ext:jpg,png,jpeg,webp|size:5000`"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                              v-html="value.especialidad.Imagen ? 'Cambiar Imagen Mobile' : 'Subir Imagen Mobile'"
                            />
                          </template>
                          <span>Imagen para resolución móvil (Sugerido: 800x370px). Máx 5MB.</span>
                        </v-tooltip>
                        <v-file-input
                          v-model="value.imagenMobile"
                          small-chips
                          :error-messages="errors"
                          label="Formato: jpg, png, webp"
                          dense
                          filled
                          color="success"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Atributo Alt"
                        :rules="`${(value.imagen || value.imagenMobile || value.especialidad.Imagen) ? 'required|' : ''}max:100`"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">Atributo "ALT" de la imagen (SEO)</label>
                          </template>
                          <span>Este atributo es obligatorio si existe una imagen.</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.Alt"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Atributo Title"
                        :rules="`${(value.imagen || value.imagenMobile || value.especialidad.Imagen) ? 'required|' : ''}max:100`"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" class="grey--text" v-on="on">Atributo "Title" de la imagen (SEO)</label>
                          </template>
                          <span>Este atributo es obligatorio si existe una imagen.</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.especialidad.Title"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="row-breakdown-items mt-5">
                      <v-row class="row-breakdown-items__title">
                        <v-col class="main">
                          <h3>
                            Meta Tags
                            <v-icon dark>{{ $vuetify.icons.values.tagPlus || 'mdi-tag-plus' }}</v-icon>
                          </h3>
                          <v-btn color="info" :small="$vuetify.breakpoint.xs" @click="abrirCrearMetaTag()">
                            <v-icon>{{ $vuetify.icons.values.plusBox || 'mdi-plus-box' }}</v-icon> Crear Nuevo MetaTag
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="row-breakdown-items__content">
                        <v-col class="col-12">
                          <v-row class="row-breakdown-items__form">
                            <v-col class="col-12 col-md-6 inputs">
                              <v-text-field v-model="value.metaTagBox.name" label="Name" solo />
                              <v-text-field v-model="value.metaTagBox.content" label="Content" solo />
                              <v-btn v-if="value.metaTagModoCreacion" color="info" @click="crearMetaTag()">Crear</v-btn>
                              <v-btn v-else color="success" @click="editarMetaTag()">Editar</v-btn>
                            </v-col>
                            <v-col class="col-12 col-md-6 alerts">
                              <div class="alert-main">
                                <v-alert v-if="showMsgMetaTag" dense text :type="typeMsgMetaTag">
                                  <span v-html="msgMetaTag" />
                                </v-alert>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="row-breakdown-items__table justify-center">
                            <v-col class="col-12"><div class="divider" /></v-col>
                            <v-col v-if="value.especialidad.MetaTags && value.especialidad.MetaTags.length > 0" class="col-12 mt-5 mb-5 table-main">
                              <v-simple-table dense>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">Name</th>
                                      <th class="text-left">Content</th>
                                      <th>Editar</th>
                                      <th>Eliminar</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(item, i) in value.especialidad.MetaTags" :key="i">
                                      <td>{{ item.Name }}</td>
                                      <td>{{ item.Content }}</td>
                                      <td class="td-btn">
                                        <v-btn color="info" small @click="abrirEditarMetaTag(i)">
                                          <v-icon>{{ $vuetify.icons.values.pencil || 'mdi-pencil' }}</v-icon>
                                        </v-btn>
                                      </td>
                                      <td class="td-btn">
                                        <v-btn color="error" small @click="eliminarMetaTag(i)">
                                          <v-icon>{{ $vuetify.icons.values.delete || 'mdi-delete' }}</v-icon>
                                        </v-btn>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                            <v-col v-else class="no-breakdown-items">
                              Aún no has añadido metatags a este tipo de especialidad
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col class="row-breakdown-items mt-5">
                      <v-row class="row-breakdown-items__title">
                        <v-col class="main">
                          <h3>
                            Contenidos Adicionales
                            <v-icon dark>mdi-text-box-plus</v-icon>
                          </h3>
                          <v-btn color="info" :small="$vuetify.breakpoint.xs" @click="abrirCrearContenido()">
                            <v-icon>{{ $vuetify.icons.values.plusBox || 'mdi-plus-box' }}</v-icon> Crear Nuevo Contenido
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row class="row-breakdown-items__content">
                        <v-col class="col-12">
                          <validation-observer ref="obsContenido">
                            <v-row class="row-breakdown-items__form p-4">

                              <v-col cols="12" md="3">
                                <validation-provider v-slot="{ errors }" name="Título Bloque" rules="max:100">
                                  <v-text-field
                                    v-model="value.contenidoBox.Titulo"
                                    label="Título del Bloque (Opcional)"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="3">
                                <validation-provider v-slot="{ errors }" name="Etiqueta Título" :rules="value.contenidoBox.Titulo ? 'required' : ''">
                                  <v-select
                                    v-model="value.contenidoBox.EtiquetaTitulo"
                                    :items="opcionesEtiquetas"
                                    label="Etiqueta"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="3">
                                <validation-provider v-slot="{ errors }" name="Color Hex Título" :rules="value.contenidoBox.Titulo ? 'required|max:7' : 'max:7'">
                                  <v-text-field
                                    v-model="value.contenidoBox.TituloHexColor"
                                    label="Color Título (#FFFFFF)"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="3">
                                <validation-provider v-slot="{ errors }" name="Color Hex Fondo" :rules="value.contenidoBox.Titulo ? 'required|max:7' : 'max:7'">
                                  <v-text-field
                                    v-model="value.contenidoBox.TituloHexBg"
                                    label="Color Fondo (#000000)"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="6">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Imagen Desktop Bloque"
                                  :rules="`${value.contenidoBox.ImagenMobileFile ? 'required|' : ''}ext:jpg,png,jpeg,webp|size:5000`"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <label
                                        v-bind="attrs"
                                        class="grey--text mb-1 d-block"
                                        v-on="on"
                                        v-html="value.contenidoBox.Imagen ? 'Imagen Desktop Actual: <span style=\'color:#ff9800\'>' + value.contenidoBox.Imagen + '</span>' : 'Subir Imagen Desktop (Opcional)'"
                                      />
                                    </template>
                                    <span>Sugerido: 1900x530px. Máx 5MB.</span>
                                  </v-tooltip>
                                  <v-file-input
                                    v-model="value.contenidoBox.ImagenFile"
                                    small-chips
                                    :error-messages="errors"
                                    label="Formato: jpg, png, webp"
                                    dense filled hide-details="auto" color="success" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="6">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Imagen Mobile Bloque"
                                  :rules="`${value.contenidoBox.ImagenFile ? 'required|' : ''}ext:jpg,png,jpeg,webp|size:5000`"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <label
                                        v-bind="attrs"
                                        class="grey--text mb-1 d-block"
                                        v-on="on"
                                        v-html="value.contenidoBox.Imagen ? 'Imagen Mobile Actual: <span style=\'color:#ff9800\'>' + value.contenidoBox.Imagen + '</span>' : 'Subir Imagen Mobile (Opcional)'"
                                      />
                                    </template>
                                    <span>Sugerido: 800x370px. Máx 5MB.</span>
                                  </v-tooltip>
                                  <v-file-input
                                    v-model="value.contenidoBox.ImagenMobileFile"
                                    small-chips
                                    :error-messages="errors"
                                    label="Formato: jpg, png, webp"
                                    dense filled hide-details="auto" color="success" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" md="6">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Alt Bloque"
                                  :rules="`${(value.contenidoBox.ImagenFile || value.contenidoBox.ImagenMobileFile || value.contenidoBox.Imagen) ? 'required|' : ''}max:100`"
                                >
                                  <v-text-field
                                    v-model="value.contenidoBox.Alt"
                                    label="Alt de la Imagen (Obligatorio si hay imagen)"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" md="6">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Title Bloque"
                                  :rules="`${(value.contenidoBox.ImagenFile || value.contenidoBox.ImagenMobileFile || value.contenidoBox.Imagen) ? 'required|' : ''}max:100`"
                                >
                                  <v-text-field
                                    v-model="value.contenidoBox.Title"
                                    label="Title de la Imagen (Obligatorio si hay imagen)"
                                    :error-messages="errors"
                                    solo dense hide-details="auto" class="mb-3"
                                  />
                                </validation-provider>
                              </v-col>

                              <v-col cols="12">
                                <span class="grey--text d-block mb-2">Contenido HTML <strong class="red--text">* (Obligatorio)</strong></span>
                                <vue-editor
                                  v-model="value.contenidoBox.Html"
                                  :editor-toolbar="editorToolbarOptions"
                                  style="background: white;"
                                  :class="{'validation-error-box': errorHtml}"
                                />
                                <span v-if="errorHtml" class="validation-error-title text-caption mt-1">
                                  El contenido HTML es requerido para guardar este bloque.
                                </span>
                              </v-col>

                              <v-col cols="12" class="d-flex align-center justify-space-between mt-3">
                                <div class="alert-main" style="width: 60%;">
                                  <v-alert v-if="showMsgContenido" dense text :type="typeMsgContenido" class="ma-0">
                                    <span v-html="msgContenido" />
                                  </v-alert>
                                </div>
                                <v-btn v-if="value.contenidoModoCreacion" color="info" @click="crearContenido()">Crear Bloque</v-btn>
                                <v-btn v-else color="success" @click="editarContenido()">Guardar Edición</v-btn>
                              </v-col>
                            </v-row>
                          </validation-observer>

                          <v-row class="row-breakdown-items__table justify-center">
                            <v-col class="col-12"><div class="divider" /></v-col>
                            <v-col v-if="value.especialidad.Contenido && value.especialidad.Contenido.length > 0" class="col-12 col-md-11 mt-5 mb-5 table-main">
                              <v-simple-table dense>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">Título</th>
                                      <th class="text-left">Colores</th>
                                      <th class="text-left">Dsk / Mob</th>
                                      <th style="width: 80px">Editar</th>
                                      <th style="width: 80px">Eliminar</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(item, i) in value.especialidad.Contenido" :key="i">
                                      <td>
                                        <span class="grey--text">{{ item.Titulo || 'Sin Título' }}</span>
                                        <v-chip x-small class="ml-2" v-if="item.Titulo">{{ item.EtiquetaTitulo || 'h2' }}</v-chip>
                                      </td>
                                      <td>
                                        <span v-if="item.TituloHexColor || item.TituloHexBg">
                                          {{ item.TituloHexColor || 'N/A' }} / {{ item.TituloHexBg || 'N/A' }}
                                        </span>
                                        <span v-else class="grey--text">N/A</span>
                                      </td>
                                      <td>
                                        <v-icon v-if="item.Imagen || item.ImagenFile" color="success" small class="mr-1">mdi-monitor</v-icon>
                                        <v-icon v-else color="grey" small class="mr-1">mdi-monitor-off</v-icon>
                                        <v-icon v-if="item.Imagen || item.ImagenMobileFile" color="success" small>mdi-cellphone</v-icon>
                                        <v-icon v-else color="grey" small>mdi-cellphone-off</v-icon>
                                      </td>
                                      <td class="td-btn">
                                        <v-btn color="info" small @click="abrirEditarContenido(i)">
                                          <v-icon>{{ $vuetify.icons.values.pencil || 'mdi-pencil' }}</v-icon>
                                        </v-btn>
                                      </td>
                                      <td class="td-btn">
                                        <v-btn color="error" small @click="eliminarContenido(i)">
                                          <v-icon>{{ $vuetify.icons.values.delete || 'mdi-delete' }}</v-icon>
                                        </v-btn>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                            <v-col v-else class="no-breakdown-items">
                              Aún no has añadido bloques de contenido adicional
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="cerrar()">Cerrar</v-btn>
              <v-btn color="success" default type="submit" :disabled="invalid" :loading="value.loader">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ShowDialogTipoEspecialidad',
  components: {
    VueEditor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        active: false,
        especialidad: {},
        imagen: null,
        imagenMobile: null,
        loader: false,
        metaTagBox: { name: '', content: '' },
        metaTagModoCreacion: true,

        contenidoBox: {
          Html: '',
          Titulo: '',
          EtiquetaTitulo: 'h2',
          TituloHexColor: null,
          TituloHexBg: null,
          Imagen: null,
          ImagenFile: null,
          ImagenMobileFile: null,
          Alt: null,
          Title: null
        },
        contenidoModoCreacion: true
      })
    },
  },
  data() {
    return {
      // Estado MetaTags
      showMsgMetaTag: false,
      msgMetaTag: '',
      typeMsgMetaTag: '',
      metaTagIdEditar: null,

      // Estado visual y de validación de Contenidos Adicionales
      contenidoIdEditar: null,
      showMsgContenido: false,
      msgContenido: '',
      typeMsgContenido: '',
      errorHtml: false,

      // Opciones del v-select de Etiquetas
      opcionesEtiquetas: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div', 'span'],

      // Opciones Editor
      editorToolbarOptions: require('@/data/editorToolbarOptions.json'),
    }
  },
  watch: {
    'value.active': function (val) {
      if (val) {
        requestAnimationFrame(() => {
          if (this.$refs.observer) this.$refs.observer.reset()
        })
      }
    },
  },
  methods: {
    validar() {
      this.$emit('procesar', this.value)
    },
    cerrar() {
      this.$emit('cerrar')
    },

    // ==========================================
    // MÉTODOS META TAGS
    // ==========================================
    abrirEditarMetaTag(index) {
      this.metaTagIdEditar = index
      this.value.metaTagModoCreacion = false
      this.value.metaTagBox.name = this.value.especialidad.MetaTags[index].Name
      this.value.metaTagBox.content = this.value.especialidad.MetaTags[index].Content
    },
    abrirCrearMetaTag() {
      this.value.metaTagModoCreacion = true
      this.value.metaTagBox = { name: '', content: '' }
    },
    crearMetaTag() {
      if (!this.value.metaTagBox.name || !this.value.metaTagBox.content) {
        this.showAlertMetaTag('Faltan campos por llenar', 'error')
        return
      }
      const element = {
        Name: this.value.metaTagBox.name,
        Content: this.value.metaTagBox.content,
      }
      if (!this.value.especialidad.MetaTags) {
        this.$set(this.value.especialidad, 'MetaTags', [])
      }
      this.value.especialidad.MetaTags.push(element)
      this.limpiaMetaTagBox()
      this.showAlertMetaTag('Registro creado. Debe grabar para guardar cambios definitivamente', 'success')
    },
    editarMetaTag() {
      this.value.especialidad.MetaTags[this.metaTagIdEditar].Content = this.value.metaTagBox.content
      this.value.especialidad.MetaTags[this.metaTagIdEditar].Name = this.value.metaTagBox.name
      this.limpiaMetaTagBox()
      this.showAlertMetaTag('Registro editado. Debe grabar para guardar cambios definitivamente', 'success')
    },
    eliminarMetaTag(index) {
      if (confirm('¿Estás seguro/a que deseas eliminar este MetaTag?')) {
        this.value.especialidad.MetaTags.splice(index, 1)
        this.limpiaMetaTagBox()
        this.showAlertMetaTag('Registro eliminado. Debe grabar para guardar cambios', 'warning')
      }
    },
    showAlertMetaTag(msg, type) {
      this.msgMetaTag = msg
      this.typeMsgMetaTag = type
      this.showMsgMetaTag = true
      setTimeout(() => {
        this.showMsgMetaTag = false
      }, 6000)
    },
    limpiaMetaTagBox() {
      this.value.metaTagModoCreacion = true
      this.value.metaTagBox.name = ''
      this.value.metaTagBox.content = ''
      this.metaTagIdEditar = null
    },

    // ==========================================
    // MÉTODOS CONTENIDOS ADICIONALES
    // ==========================================
    abrirCrearContenido() {
      this.value.contenidoModoCreacion = true
      this.limpiaContenidoBox()
      if(this.$refs.obsContenido) this.$refs.obsContenido.reset()
    },
    validarContenidoRequerido() {
      if (!this.value.contenidoBox.Html || this.value.contenidoBox.Html.trim() === '' || this.value.contenidoBox.Html === '<p></p>') {
        this.errorHtml = true;
        return false;
      }
      this.errorHtml = false;
      return true;
    },
    async crearContenido() {
      const isValid = await this.$refs.obsContenido.validate();
      if (!isValid) return;

      if (!this.validarContenidoRequerido()) return;

      const element = { ...this.value.contenidoBox }
      if (!this.value.especialidad.Contenido) {
        this.$set(this.value.especialidad, 'Contenido', [])
      }
      this.value.especialidad.Contenido.push(element)
      this.limpiaContenidoBox()
      this.showAlertContenido('Bloque creado. Graba el formulario para confirmar cambios', 'success')
      if(this.$refs.obsContenido) this.$refs.obsContenido.reset()
    },
    abrirEditarContenido(index) {
      this.contenidoIdEditar = index
      this.value.contenidoModoCreacion = false
      this.errorHtml = false
      this.value.contenidoBox = { ...this.value.especialidad.Contenido[index] }
    },
    async editarContenido() {
      const isValid = await this.$refs.obsContenido.validate();
      if (!isValid) return;
      if (!this.validarContenidoRequerido()) return;

      this.value.especialidad.Contenido.splice(this.contenidoIdEditar, 1, { ...this.value.contenidoBox })
      this.limpiaContenidoBox()
      this.showAlertContenido('Bloque editado. Graba el formulario para confirmar cambios', 'success')
      if(this.$refs.obsContenido) this.$refs.obsContenido.reset()
    },
    eliminarContenido(index) {
      if (confirm('¿Estás seguro/a que deseas eliminar este Bloque de Contenido?')) {
        this.value.especialidad.Contenido.splice(index, 1)
        this.limpiaContenidoBox()
        this.showAlertContenido('Bloque eliminado. Graba para guardar cambios', 'warning')
      }
    },
    limpiaContenidoBox() {
      this.value.contenidoModoCreacion = true
      this.contenidoIdEditar = null
      this.errorHtml = false
      this.value.contenidoBox = {
        Html: '',
        Titulo: null,
        EtiquetaTitulo: 'h2',
        TituloHexColor: null,
        TituloHexBg: null,
        Imagen: null,
        ImagenFile: null,
        ImagenMobileFile: null,
        Alt: null,
        Title: null
      }
    },
    showAlertContenido(msg, type) {
      this.msgContenido = msg
      this.typeMsgContenido = type
      this.showMsgContenido = true
      setTimeout(() => {
        this.showMsgContenido = false
      }, 6000)
    }
  },
}
</script>

<style lang="sass" scoped>
@import '@/sass/variables2'

.pre-formatted
  white-space: pre

.validation-error-box
  border: 1px solid #ff6668 !important

.validation-error-title
  color: #ff6668
  display: block

.ql-editor
  height: 200px !important

.chk-especialidades__main
  overflow-y: scroll
  height: 600px

.label-img
  color: #9e9e9e
  span
    color: $orange

.v-card
  .dialog-especialidad-titulo
    h3
      color: $green !important
      display: inline
    span
      color: #9e9e9e
      text-transform: capitalize
      font-weight: bold

.label-span
  font-size: 13px !important
  color: $green

.row-breakdown-items__content
  background: $lightblack4
  .row-breakdown-items__form
    background: #fcfcfc
    border-radius: 4px
    .inputs
      display: flex
      flex-direction: column
      justify-content: space-between
      padding: 20px
      .v-btn
        margin-right: 0px
        width: 200px
    .alerts
      display: flex
      flex-direction: column
      justify-content: space-between
      padding: 20px
      .alert-main
        height: 50px
      span
        font-weight: 300 !important
        font-size: 14px
      .v-btn
        margin-right: 0px
        width: 200px
  .row-breakdown-items__table
    .td-btn
      width: 50px
    .divider
      width: 100%
      height: 2px
      background: $lightblack3
    .table-main
      background: $white
    .no-breakdown-items
      text-align: center
      padding: 20px
      background: $lightblack4
</style>
